import axios from '@/CommonDP/utils/request';
export const modelVideoFileSave = (data) => axios.post('/model-file-preview/save', data);
export const modelVideoFileList = (data) => axios.post('/model-file-preview/list', data);
export const modelVideoFileEdit = (data) => axios.post('/model-file-preview/edit', data);
export const modelVideoFileDelete = (data) => axios.post('/model-file-preview/batchDelete', data);
